// Do NOT add "use client" to this file
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

import * as styles from "./productName.css";

export const ProductName = ({ productName }: { productName: string }) => {
  return (
    <div className={styles.productLine}>
      <Typography
        className={styles.productLineFlexibleHeight}
        variant="paragraphSansMedium"
        data-test-id="product-tile-product-name"
      >
        {productName}
      </Typography>
    </div>
  );
};
